module.exports = __webpack_public_path__ + "static/almiraj-ec3209eebae554820fbd3805e030e8f2.png";